// src/project/data/fetches/packagesDone.js
import { buildUrlWithAuth, RIDER_ENDPOINTS, getRiderId } from '../config/apiConfig'
import parseExternalDelivery from '../scripts/parseExternalDelivery'

export default {
  url() {
    const riderId = getRiderId()
    return buildUrlWithAuth(RIDER_ENDPOINTS.PACKAGE_LIST, {
      riderId,
      status: 'delivered',
    })
  },
  parse(raw = {}) {
      console.log("🚀 ~ raw:", raw)
    if (raw?.statusCode === 404) {
      return {
        statusCode: 200,
        message: 'Empty',
        data: [],
      }
    }
    if (raw?.statusCode !== 200 && !raw?.data) {
      return { statusCode: raw?.statusCode || 500, data: [] }
    }

    const deliveries = Array.isArray(raw?.data?.data)
      ? raw.data.data
      : Array.isArray(raw?.data?.items)
      ? raw.data.items
      : Array.isArray(raw?.data)
      ? raw.data
      : []

    return {
      statusCode: 200,
      message: 'Ok',
      data: deliveries.map((d) => parseExternalDelivery(d)).filter(Boolean),
    }
  },
}
